import Axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import ElementUI from 'element-ui'
import xesCookie from 'src/utils/utils'

// 设置所有请求的baseURL
// courseware.test.com/api
// courseware.saasz.vdyoo.com/api
// axios.defaults.baseURL = 'http://courseware.test.com/api'
const axios = Axios.create()
axios.defaults.baseURL = 'https://courseware.saasz.vdyoo.com/api'
if (window.location.href.split('://')[0] == 'http') {
    axios.defaults.baseURL = 'http://courseware.saasz.vdyoo.com/api'
}
// axios.defaults.baseURL = '/api'
axios.defaults.withCredentials = true

// 设置发送请求拦截器
axios.interceptors.request.use(req => {
    // 若请求post请求并且methodType == 1，则是x-www-form-urlencoded请求，需要设置Content-Type和使用qs进行序列化参数
    if (req.method === 'post' && req.methodType === 1) {
        req.headers = Object.assign({}, req.headers, {
            'Content-Type':
                'application/x-www-form-urlencoded,multipart/form-data;charset=UTF-8'
        })
        req.data = qs.stringify(req.data)
    }

    // 若请求post请求并且methodType == 3，则是x-www-form-urlencoded请求，需要设置Content-Type和使用qs进行序列化参数
    if (req.method === 'post' && req.methodType === 3) {
        req.headers = Object.assign({}, req.headers, {
            'Content-Type':
                'application/x-www-form-urlencoded,multipart/form-data;charset=UTF-8'
        })
        req.data = qs.stringify(req.data)
    }

    // 如果是本地开发环境，则增加一个参数
    const nodeEnv = process.env.NODE_ENV
    if (nodeEnv === 'development') {
        req.headers = Object.assign({}, req.headers, {
            // 'Authorization': 'wx=ac3534f3e2f0761d9cd34c73fd190e0899x0q4y90m; X-Request-Id=2821689ed07fa0993ed08b1a34b525ea'
        })
        req.params = Object.assign({}, req.params, {
            // isLocalRequest: 1
        })
    }

    // 所有请求添加token
    req.headers['jytoken'] = window.token
    // console.log(req)
    return req
})

// 设置请求返回拦截器
axios.interceptors.response.use(response => {
    const result = response.data
    if (response.config.customGo) {
        return response
    }

    if (result.status === 1005 || result.status === 1001) {
        xesCookie.delCookie('token')
        ElementUI.MessageBox.alert(result.data, '提示', {
            confirmButtonText: '确定',
            callback: action => {
                const url = xesCookie.getUrlParams('domain')
                window.location.href = url || 'https://tnt.saasz.vdyoo.com/'
            }
        })
        // return response
    } else if (result.status === 100) {
        // 成功的请求
        return result.data
    } else if (result.status === 1009 || result.status === 10010) {
        return Promise.reject(result)
    } else {
        // 当后端返回非100的code，且不是需要特殊处理的code则直接弹出后端提示文本
        if (result.status) {
            ElementUI.MessageBox.alert(result.data, '提示', {
                confirmButtonText: '确定'
            })
            return Promise.resolve(result)
        }
    }
})
Vue.prototype.$qs = qs
Vue.prototype.$axios = axios
Vue.prototype.$http = axios

export default axios



// WEBPACK FOOTER //
// ./src/config/axios.js